import { cn } from '@/lib/cn';

export function Skeleton({
  className,
  style,
}: {
  className?: string;
  style?: React.CSSProperties;
}): JSX.Element {
  return (
    <div
      className={cn(
        'animate-pulse rounded-md bg-[var(--color-surface-sunken)]',
        className,
      )}
      style={style}
    />
  );
}

/** Vertical stack of N row skeletons sized for table layouts. */
export function TableSkeleton({ rows = 6 }: { rows?: number }): JSX.Element {
  return (
    <div className="card-flat card">
      <div className="space-y-3">
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} className="h-10 w-full" />
        ))}
      </div>
    </div>
  );
}
